import { FC } from 'react';
import {
  HeroConversation,
  useGetTwilioConversationUnreadMessagesCount,
} from '@vs-online-only-app/state';
import ConversationItemCard from './ConversationItemCard';
import useConversationShopperStatus from '../../hooks/useConversationShopperStatus';

type Props = {
  conversation: HeroConversation;
};

const ActiveConversationItem: FC<Props> = ({ conversation }) => {
  const shopperStatus = useConversationShopperStatus({
    conversationId: conversation.id,
  });

  const { data: unreadMessagesCount } =
    useGetTwilioConversationUnreadMessagesCount(
      conversation.twilioConversationId
    );

  return (
    <ConversationItemCard
      conversation={conversation}
      shopperStatus={shopperStatus}
      unreadMessagesCount={unreadMessagesCount}
    />
  );
};

export default ActiveConversationItem;
